// extracted by mini-css-extract-plugin
export default {"title":"PaymentToWholesalerDetails_title__PGOeU","total":"PaymentToWholesalerDetails_total__-X-3y","edit":"PaymentToWholesalerDetails_edit__pq-tv"};